import { Component, Input } from '@angular/core';
import {
  RetailItemStoreService,
  SALE_ITEM_SERVICE
} from '../../../shared/retail-item-list/retail-item.store.service';
import { WorkshopJobRetailItemSaleService } from '../../../shared/services/workshop-job-retail-item-sale.service';
import { WORKSHOP } from '../../../../testIds';
import { RetailItemListComponent } from '../../../shared/retail-item-list/retail-item-list.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgIf } from '@angular/common';
import { MatCard, MatCardContent } from '@angular/material/card';

@Component({
    selector: 'app-parts-list',
    templateUrl: './parts-list.component.html',
    providers: [
        RetailItemStoreService,
        { provide: SALE_ITEM_SERVICE, useClass: WorkshopJobRetailItemSaleService }
    ],
    standalone: true,
    imports: [MatCard, MatCardContent, NgIf, NgxSkeletonLoaderModule, RetailItemListComponent]
})
export class PartsListComponent {
  @Input() job = null;

  @Input() finalized = false;
  testIds = WORKSHOP;
}
